import { DropDownList } from '@core/interfaces';

import { Columns } from '#types/grid';

export function setColumnList(columns: Columns, field: string, list: DropDownList): Columns {
  for (let i = 0; i < list.length; i++) {
    // remove disabled entries from the list (typically headers)
    if (list[i].disabled) {
      list.splice(i, 1);
    }
  }

  for (const column of columns) {
    if (column.field === field && column.editable) {
      if (!column.editOptions) {
        column.editOptions = {};
      }

      column.editOptions.list = [...list];
    }
  }

  return columns;
}
